module.exports = __webpack_public_path__ + "img/exim.a5574019.png";